import React, { useRef, useState, useEffect } from "react";
import { Select, Modal } from '@appkit4/react-components'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Button } from '@appkit4/react-components';
import { FormControl } from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import Loader from '../Loader/Loader';
import api from "../../apis/api";
import { sessionTimeout } from "../../store/authSlice";
import { useDispatch } from "react-redux";
import { Tooltip } from '@appkit4/react-components/tooltip';

import { CalendarPicker } from '@appkit4/react-components/datepicker';
import dayjs from 'dayjs';
import { Input } from '@appkit4/react-components';
type ValueType = string | number;
type SelectValue = ValueType | ValueType[];
interface DropdownItem {
    value: ValueType;
    label: string;
}

const ExcelDraftGeneration: React.FC = () => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [activeStepExcel, setActiveStepExcel] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set<number>());
    const azuresearchId = useSelector((state: RootState) => state.auth.azuresearchId)
    const fileInputRef = useRef<HTMLInputElement | null>(null)
    const [loading, setLoading] = useState<Boolean>(false);
    const [value, setValue] = React.useState<SelectValue>('Deals Due Diligence');
    const [selectedFiles, setSelectedFiles] = useState<FileList | null>(null);
    const [schemeName, setSchemeName] = useState('');
    const [projectName, setProjectName] = useState('');
    const [generatedSteps, setGeneratedSteps] = useState<{ [key: number]: boolean }>({});
    const [schemeValue, setSchemeValue] = React.useState<SelectValue>('Test value');
    const [valuationDate, setValuationDate] = useState<Date | undefined>(undefined);
    const [previousValuationDate, setPreviousValuationDate] = useState<Date | undefined>(undefined);
    const [previousValuationPlusOneDate, setPreviousValuationPlusOneDate] = useState<Date | undefined>(undefined);
    const [reportDate, setReportDate] = useState<Date | undefined>(undefined);
    const [valuationUpdateDate, setValuationUpdateDate] = useState<Date | undefined>(undefined);
        const [valuationPreviousDate, setValuationPreviousDate] = useState<Date | undefined>(undefined);
    const [currentFinancialFiles, setCurrentFinancialFiles] = useState<File[]>([]);
    const [previousFinancialFiles, setPreviousFinancialFiles] = useState<File[]>([]);
    const [schemeValuationFiles, setSchemeValuationFiles] = useState<File[]>([]);
    const [additionalFiles, setAdditionalFiles] = useState<File[]>([]);
    const [isfileUploaded, setIsfileUploadedEnabled] = useState(false);
    const [isGenerateButtonEnabled, setGenerateButtonEnabled] = useState(false);
    const [isFormDisabled, setFormDisabled] = useState(false);
    const [isDownloadEnabled, setDownloadEnabled] = useState(false);
    const [modalContent, setModalContent] = useState({ title: '', message: '' });
    const [isModal, setModal] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [excelDocumentFile, setExcelDocumentFile] = useState(null);
    const excelSteps = ['Choose Templates', 'Upload Documents', 'Fill Details', 'Download Excel'];
    const fileInputRefs = {
        currentFinancial: useRef<HTMLInputElement>(null),
        previousFinancial: useRef<HTMLInputElement>(null),
        schemeValuation: useRef<HTMLInputElement>(null),
        additionalDocuments: useRef<HTMLInputElement>(null),
    };

    const schemetypeData: DropdownItem[] = [
        { value: 'Test value', label: 'Test value' },
        { value: 'Test value2', label: 'Test value2' },
    ];
    const data: DropdownItem[] = [
        { value: 'Deals Due Diligence', label: 'Deals Due Diligence' },
        { value: 'Meeting Minutes', label: 'Meeting Minutes' },
    ];
    const handleFileUploadClick = (ref: React.RefObject<HTMLInputElement>) => {
        ref.current?.click();
    };

    const handleBackExcel = () => {
        setActiveStepExcel((prevActiveStep) => prevActiveStep - 1);
    };
    const handleSelectChangeForTemplate = (selectedValue: SelectValue) => {
        setValue(selectedValue);
    };
    const handleFileSelection = (setFiles: React.Dispatch<React.SetStateAction<File[]>>, isMultiple: boolean) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            if (isMultiple) {
                setFiles(Array.from(files));
            } else {
                setFiles([files[0]]);
            }
        }
        checkFormCompletion();
    };
    const handleSelectChangeForscheme = (selectedValue: SelectValue) => {
        setSchemeValue(selectedValue);
    };
    const handleNextExcel = () => {
        let newSkipped = skipped;
        if (activeStepExcel === excelSteps.length - 1) {
            // Finish clicked: reset everything
            setActiveStepExcel(0);
            setSkipped(new Set());
        } else {
            setActiveStepExcel((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        }
    };
    const inputStyles = {
        width: '152%',
        background: '#ffff'
    };
    const dispatch = useDispatch()


    const generate = async () => {
        const formData = new FormData();
        const appendFiles = (files: File[], key: string) => {
            files.forEach(file => {
                formData.append(key, file);
            });
        };
        appendFiles(currentFinancialFiles, 'currentFinancial');
        appendFiles(previousFinancialFiles, 'previousFinancial');
        appendFiles(schemeValuationFiles, 'scheme_valuation_update_doc');
        appendFiles(additionalFiles, 'additionalDocuments');
        formData.append('azuresearchId', azuresearchId)
        console.log(JSON.stringify(formData), 'formData')
        setLoading(true);

        try {
            const dguploadurl = process.env.REACT_APP_DGUPLOAD
            if (!dguploadurl) {
                throw Error('API url is missing')
            }
            const response = await api.post(dguploadurl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })

            toast.success("File uploaded successfully", {
                position: "top-right",
                autoClose: 5000
            });
            setModalContent({ title: 'Success', message: 'File uploaded successfully' });
            setGeneratedSteps(prev => ({ ...prev, [activeStepExcel]: true }));
            setGenerateButtonEnabled(false);
            setIsfileUploadedEnabled(true);
        }
        catch (err: any) {
            console.error(err)
            if (err.status === 500) {
                toast.error(err.response.data.error, {
                    position: "top-right",
                    autoClose: 5000
                });
                if (err.response.data.error) {
                    setModalContent({ title: 'Failure', message: err.response.data.error });
                } else {
                    setModalContent({ title: 'Failure', message: 'File upload failed!' });
                }
            }
            else if (err.status === 401) {
                toast.error(err.response.data.error, {
                    position: "top-right",
                    autoClose: 5000
                });
                if (err.response.data.error) {
                    setModalContent({ title: 'Failure', message: err.response.data.error });
                } else {
                    setModalContent({ title: 'Failure', message: 'File upload failed!' });
                }
                dispatch(sessionTimeout(true))
            }
            else {
                toast.error("File upload failed!", {
                    position: "top-right",
                    autoClose: 5000
                });
                if (err.response.data) {
                    setModalContent({ title: 'Failure', message: err.response.data });

                } else {
                    setModalContent({ title: 'Failure', message: 'File upload failed!' });

                }
            }
        }
        finally {
            setLoading(false);
            setModal(true);
        }
    };
    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        return dayjs(date).format('DD/MM/YYYY');
    };
    const handleResetForm = () => {
        //reset validations
        setIsfileUploadedEnabled(false);
        setGenerateButtonEnabled(false);
        setFormDisabled(false);
        setDownloadEnabled(false);
        // Reset text inputs
        setProjectName("");
        setSchemeName("");

        // Reset dates
        setReportDate(undefined);
        setPreviousValuationDate(undefined);
        setPreviousValuationPlusOneDate(undefined);
        setValuationDate(undefined);
        setValuationUpdateDate(undefined);
        setValuationPreviousDate(undefined);

        // Reset uploaded files
        setCurrentFinancialFiles([]);
        setPreviousFinancialFiles([]);
        setSchemeValuationFiles([]);
        setAdditionalFiles([]);

        // Reset stepper and form state
        setActiveStepExcel(0);
        setGeneratedSteps([false, false, false]);

        // Clear file input refs
        Object.values(fileInputRefs).forEach(ref => {
            if (ref?.current) {
                ref.current.value = '';
            }
        });
    };

    const handleDownload = async () => {
        try {
            setLoading(true);
            let generateExcel: string = 'true';
            let generateTemplate: string = 'false';
            const fileNames = [
                ...currentFinancialFiles.map(file => file.name),
                ...previousFinancialFiles.map(file => file.name),
                ...schemeValuationFiles.map(file => file.name)
            ];
            const draftStatus = Array.isArray(value) ? value[0] : value;
            console.log(fileNames)
            const formattedReportDate = formatDate(reportDate);
            const formattedValuationDate = formatDate(valuationDate);
            const formattedValuationPreviousDate = formatDate(valuationPreviousDate);
            let formattedValuationUpdateDate = formatDate(valuationUpdateDate);
            const formattedPreviousValuationDate = formatDate(previousValuationDate);
            const formattedPreviousValuationPlusOneDate = formatDate(previousValuationPlusOneDate);
            const formData = new FormData();
            if (formattedValuationUpdateDate === 'Invalid Date') {
                formattedValuationUpdateDate = '';
            }
            formData.append('azuresearchId', azuresearchId)
            formData.append('draftStatus', String(draftStatus))
            formData.append('generateTemplate', generateTemplate)
            formData.append('generateExcel', generateExcel)
            formData.append('projectName', projectName)
            formData.append('schemeName', schemeName)
            formData.append('schemeType', '1')
            formData.append('financialAccountsLatestDate', formattedReportDate)
            formData.append('financialAccountsPreviousDate', formattedPreviousValuationDate)
            formData.append('financialAccountstwoYearsPreviousDate', formattedPreviousValuationPlusOneDate)
            formData.append('schemeValuationLatestDate', formattedValuationDate)
            formData.append('schemeValuationPreviousDate', formattedValuationPreviousDate)
            formData.append('schemeValuationUpdateDate', formattedValuationUpdateDate)
            formData.append('financialAccountsCurrentDoc', fileNames[0])
            formData.append('financialAccountsPreviousDoc', fileNames[1])
            formData.append('schemeValuationDoc', fileNames[2])
            console.log(JSON.stringify(formData), 'formData')
            const dgdownloadurl = process.env.REACT_APP_DGCONTENT
            if (!dgdownloadurl) {
                throw Error('API url is missing')
            }
            const response = await api.post(dgdownloadurl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a');
            link.href = url;
            console.log(response.headers);

            const contentDisposition = response.headers['content-disposition'];
            let filename = 'report.txt';
            if (contentDisposition) {
                const matches = contentDisposition.match(/filename="?(.+)"?/);
                if (matches && matches[1]) {
                    filename = matches[1];
                } else {
                    console.error("Filename extraction failed - matching issue.");
                }
            } else {
                console.error("Content-Disposition header missing in response.");
            }
            link.setAttribute('download', filename);
            // Additional security measure
            link.rel = 'noopener'; // Prevent the new tab from accessing the window object and potentially causing a security risk
            link.style.display = 'none'; // Hide the link element

            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
            // Revoke the created object URL
            window.URL.revokeObjectURL(url);
            setSelectedFiles(null)
            toast.success("File download successfully", {
                position: "top-right",
                autoClose: 5000
            });
            setFormDisabled(true);
        }
        catch (err: any) {
            if (err.status === 500) {
                toast.error("File download failed!", {
                    position: "top-right",
                    autoClose: 5000
                });
            }
            else if (err.status === 401) {
                toast.error(err.response.data.error, {
                    position: "top-right",
                    autoClose: 5000
                });
                dispatch(sessionTimeout(true))
            }
            else {
                toast.error("File download failed!", {
                    position: "top-right",
                    autoClose: 5000
                });
            }
        }
        finally {
            setLoading(false);
        }
    }
    const checkFormCompletion = () => {
        const filesCompleted = currentFinancialFiles.length > 0 &&
            previousFinancialFiles.length > 0;

        const inputsCompleted = projectName && schemeName && valuationDate && previousValuationDate && previousValuationPlusOneDate && reportDate;

        if (filesCompleted) {
            setGenerateButtonEnabled(true);
        } else {
            setGenerateButtonEnabled(false);
        }
        if (inputsCompleted) {
            setDownloadEnabled(true);
        } else {
            setDownloadEnabled(false);
        }
    };
    const handleInputChange = (setter: any) => (value: any, event: any) => {
        setter(value);
        checkFormCompletion();
    };

    const handleDateChange = (setter: any, checkFormCompletion: any) => (date: Date | Date[], isValid: boolean) => {
        setter(date);
        if (isValid && date) {
            console.log(date);
            checkFormCompletion();
        } else {
            console.log('Date is invalid or cleared');
        }

    };
    const handleValueChange = (setter: any, completionCheckCallback: any, dateString: any) => {
        // Logic to handle input change
        if (!dateString.trim()) {
            setter(undefined);
            console.log('Date cleared');
        } else {
            completionCheckCallback();
        }
    };

    useEffect(checkFormCompletion, [
        currentFinancialFiles,
        previousFinancialFiles,
        schemeValuationFiles,
        additionalFiles,
        projectName,
        schemeName,
        valuationDate,
        previousValuationDate,
        previousValuationPlusOneDate,
        reportDate,
    ]);

    return <>
        {loading && <Loader />}
        <Stepper activeStep={activeStepExcel}>
            {excelSteps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                    optional?: React.ReactNode;
                } = {};
                return (
                    <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                );
            })}
        </Stepper>
        <React.Fragment>
            {activeStepExcel === 0 && (
                <Typography sx={{ mt: 2, mb: 1 }}>
                    <div className="draftgen-choose-draft-button" >
                        <FormControl style={{ width: '320px' }} variant="outlined">
                            <Select
                                defaultValue={data[0].value}
                                data={data}
                                placeholder="Choose Drafts"
                                required={true}
                                value={value}
                                disabled={isfileUploaded}
                                onSelect={handleSelectChangeForTemplate}
                            ></Select>
                        </FormControl>
                    </div>
                </Typography>
            )}
            {activeStepExcel === 1 && (
                <Typography sx={{ mt: 2, mb: 1 }}>
                    <div className="upload-documents">
                        {[
                            { label: 'Latest Financial Accounts:', files: currentFinancialFiles, ref: fileInputRefs.currentFinancial, setFiles: setCurrentFinancialFiles, isMultiple: false },
                            { label: 'Previous Financial Accounts:', files: previousFinancialFiles, ref: fileInputRefs.previousFinancial, setFiles: setPreviousFinancialFiles, isMultiple: false },
                            { label: 'Scheme Valuation:', files: schemeValuationFiles, ref: fileInputRefs.schemeValuation, setFiles: setSchemeValuationFiles, isMultiple: false },
                            { label: 'Additional Documents:', files: additionalFiles, ref: fileInputRefs.additionalDocuments, setFiles: setAdditionalFiles, isMultiple: true },
                        ].map(({ label, files, ref, setFiles, isMultiple }) => (
                            <div key={label} style={{ display: 'flex', flexDirection: 'column', gap: '5px', paddingTop: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span>{label}</span>
                                    <Tooltip
                                        trigger='hover'
                                        position='top-right'
                                        distance={4}
                                        content={`Select ${label.toLowerCase()}`}
                                    >
                                        <CloudUploadIcon
                                            onClick={() => handleFileUploadClick(ref)}
                                            style={{ cursor: isfileUploaded ? 'not-allowed' : 'pointer', opacity: isFormDisabled ? 0.5 : 1 }}
                                            className="draftgen-upload-icon"
                                        />
                                        <input
                                            type="file"
                                            multiple={isMultiple}
                                            accept=".pdf"
                                            ref={ref}
                                            style={{ display: 'none' }}
                                            disabled={isfileUploaded}
                                            onChange={handleFileSelection(setFiles, isMultiple)}
                                        />
                                    </Tooltip>
                                </div>
                                <ul>
                                    {files.map((file, index) => (
                                        <li key={index}>{file.name}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </Typography>
            )}
            {activeStepExcel === 2 && (
                <Typography sx={{ mt: 2, mb: 1 }}>
                    <div  className="valuation-section">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '210px' }}>
                            <div style={{ gap: '5px' }} className="field">
                                <label htmlFor="project-name">Project Name: </label>
                                <Input
                                    type="text"
                                    inputId="project-name"
                                    value={projectName}
                                    readonly={false}
                                    onChange={handleInputChange(setProjectName)}
                                    placeholder="Enter project name"
                                    style={inputStyles}
                                    disabled={isFormDisabled}
                                    required={true}
                                />
                            </div>
                            <div style={{ gap: '5px' }} className="field">
                                <label htmlFor="scheme-name">Scheme Name: </label>
                                <Input
                                    type="text"
                                    inputId="scheme-name"
                                    value={schemeName}
                                    readonly={false}
                                    onChange={handleInputChange(setSchemeName)}
                                    placeholder="Enter scheme name"
                                    style={inputStyles}
                                    disabled={isFormDisabled}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '100px' }}>
                            <div style={{ marginTop: '10px', gap: '5px' }} className="field">
                                <label htmlFor="project-name">Scheme Type: </label>
                                <FormControl style={{ width: '320px', display: 'flex' }} variant="outlined">
                                    <Select
                                        defaultValue={schemetypeData[0].value}
                                        data={schemetypeData}
                                        placeholder="Choose Type"
                                        required={true}
                                        value={schemeValue}
                                        disabled={isFormDisabled}
                                        onSelect={handleSelectChangeForscheme}
                                    ></Select>
                                </FormControl>
                            </div>
                            <div style={{ marginTop: '10px' }} className="field">
                                <label htmlFor="report-date">
                                    Latest financial accounts date: </label>
                                <div style={{ marginTop: '5px' }}>
                                    <CalendarPicker
                                        id="report-date"
                                        value={reportDate}
                                        fieldTitle="Select a date"
                                        format="DD/MM/YYYY"
                                        onChange={handleDateChange(setReportDate, checkFormCompletion)}
                                        locale="en"
                                        onValueChange={(dateString: any) => handleValueChange(setReportDate, checkFormCompletion, dateString)}
                                        required={true}
                                        disabled={isFormDisabled}
                                        datepickerAlwaysDown={false}
                                    />
                                </div>
                            </div>

                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '100px' }}>

                            <div style={{ marginTop: '10px' }} className="field">
                                <label htmlFor="previous-valuation-date">Previous financial accounts date: </label>
                                <div style={{ marginTop: '5px' }}>
                                    <CalendarPicker
                                        id="previous-valuation-date"
                                        value={previousValuationDate}
                                        fieldTitle="Select a date"
                                        format="DD/MM/YYYY"
                                        onChange={handleDateChange(setPreviousValuationDate, checkFormCompletion)}
                                        locale="en"
                                        onValueChange={(dateString: any) => handleValueChange(setPreviousValuationDate, checkFormCompletion, dateString)}
                                        required={true}
                                        disabled={isFormDisabled}
                                        datepickerAlwaysDown={false}
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop: '10px' }} className="field">
                                <label htmlFor="previous-valuation-plus-one-date">Two year previous financial accounts date: </label>
                                <CalendarPicker
                                    id="previous-valuation-plus-one-date"
                                    value={previousValuationPlusOneDate}
                                    fieldTitle="Select a date"
                                    format="DD/MM/YYYY"
                                    onChange={handleDateChange(setPreviousValuationPlusOneDate, checkFormCompletion)}
                                    locale="en"
                                    onValueChange={(dateString: any) => handleValueChange(setPreviousValuationPlusOneDate, checkFormCompletion, dateString)}
                                    required={true}
                                    disabled={isFormDisabled}
                                    datepickerAlwaysDown={false}
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '100px' }}>
                            <div style={{ marginTop: '10px' }} className="field">
                                <label htmlFor="valuation-date">
                                    Scheme valuation date: </label>
                                <CalendarPicker
                                    id="valuation-date"
                                    value={valuationDate}
                                    fieldTitle="Select a date"
                                    format="DD/MM/YYYY"
                                    onChange={handleDateChange(setValuationDate, checkFormCompletion)}
                                    locale="en"
                                    onValueChange={(dateString: any) => handleValueChange(setValuationDate, checkFormCompletion, dateString)}
                                    required={true}
                                    disabled={isFormDisabled}
                                    datepickerAlwaysDown={false}
                                />
                            </div>
                            <div style={{ marginTop: '10px' }} className="field">
                                <label htmlFor="valuation-update-date">Date of scheme valuation update: </label>
                                <CalendarPicker
                                    id="valuation-update-date"
                                    value={valuationUpdateDate}
                                    fieldTitle="Select a date"
                                    format="DD/MM/YYYY"
                                    onChange={handleDateChange(setValuationUpdateDate, checkFormCompletion)}
                                    locale="en"
                                    onValueChange={(dateString: any) => handleValueChange(setValuationUpdateDate, checkFormCompletion, dateString)}
                                    required={false}
                                    disabled={isFormDisabled}
                                    datepickerAlwaysDown={false}
                                />
                            </div>
                        </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '100px' }}>
                            <div style={{ marginTop: '10px' }} className="field">
                                <label htmlFor="valuation-previous-date">Previous scheme valuation date: </label>
                                <CalendarPicker
                                    id="valuation-previous-date"
                                    value={valuationPreviousDate}
                                    fieldTitle="Select a date"
                                    format="DD/MM/YYYY"
                                    onChange={handleDateChange(setValuationPreviousDate, checkFormCompletion)}
                                    locale="en"
                                    onValueChange={(dateString: any) => handleValueChange(setValuationPreviousDate, checkFormCompletion, dateString)}
                                    required={false}
                                    disabled={isFormDisabled}
                                    datepickerAlwaysDown={false}
                                />
                            </div>
                        </div>
                    </div>
                </Typography>
            )}
            {activeStepExcel === 3 && (
                <Typography sx={{ mt: 2, mb: 1 }}>
                    <div className="downloadButton">
                        <span style={{ marginRight: '8px' }}>Download Excel</span>
                        <Tooltip
                            trigger='hover'
                            position='top-right'
                            distance={4}
                            id="tooltipDesc"
                            content='Download report in excel'>
                            <CloudDownloadIcon style={{ cursor: isDownloadEnabled ? 'pointer' : 'not-allowed', opacity: isDownloadEnabled ? 1 : 0.5, }}
                                onClick={() => {
                                    if (isDownloadEnabled) handleDownload();
                                }} className="draftgen-upload-icon" />
                        </Tooltip>
                    </div>
                </Typography>
            )}
            <Typography sx={{ mt: 2, mb: 1 }}></Typography>
            <Box sx={{ display: 'flex', paddingLeft: '15px', paddingRight:'15px', flexDirection: 'row', pt: 2 }}>
                <Button
                    color="inherit"
                    disabled={activeStepExcel === 0}
                    onClick={handleBackExcel}
                    sx={{ mr: 1 }}
                >
                    Back
                </Button>
                <Box sx={{ flex: '1 1 auto' }} />

                {activeStepExcel === 1 && (
                    <div style={{ marginRight: '15px' }}>
                        <Button
                            variant="contained"
                            onClick={generate}
                            disabled={!isGenerateButtonEnabled}
                            color="warning"
                        >
                            Upload
                        </Button>
                        <div>
                            <Modal visible={isModal}
                                className="customModal"
                                onCancel={() => setModal(false)}>
                                <h3>{modalContent.title}</h3><br></br>
                                <p>{modalContent.message}</p>
                            </Modal>
                        </div>
                    </div>
                )}
                <Button
                    onClick={() => {
                        if (activeStepExcel === excelSteps.length - 1) {
                            handleResetForm();
                        } else {
                            handleNextExcel();
                        }
                    }}
                    disabled={activeStepExcel === 1 && !generatedSteps[1]}
                >
                    {activeStepExcel === excelSteps.length - 1 ? 'Finish' : 'Next'}
                </Button>
            </Box>
        </React.Fragment>
    </>
}

export default ExcelDraftGeneration


